/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { formatTime, parseLocalDate } from 'time_formatting';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { ConfirmOrder } from './confirm_order';

import { LocalSessionStore } from '../../../local_session_store';

import { Payment } from './payment.js.jsx';
import { FocusFirst } from '../../../react/focus_first.jsx';
import { Confirmation } from './confirmation.jsx';
import { RefundRequest } from './refund_request.js.jsx';
import { RefundConfirmation } from './refund_confirmation.js.jsx';

import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import immutable from 'object-path-immutable';
import _ from 'underscore';
import moment from 'moment';

import { BuyTicketsButton } from './buy_tickets_button.jsx';
import { QuantityChooser } from './quantity_chooser.jsx';
import { AttendeeDetails } from './attendee_details.jsx';
import { RegisterModal } from './register_modal.jsx';

let finalize_called = false;

const RegisterContainer = props => <div className="em-register-checkout">
  {props.children}
</div>;

const EmptyElementsContainer = props => props.children;
const EmptyElementsConsumer = props => props.children({ stripe: null, elements: null });

    // Main component for registration checkout
    //
    // This is a little bit unconventional in that the state is primarily server controlled,
    // instead of being controlled by props. This component is essentially entirely self-contained
    // without any external integration.
    //
    // As the user works their way through the checkout process, forms are submitted over XHR
    // and new state is pushed down that is merged into with the local state after each step,
    // including which step to show.
    //
    // There is no global state beyond a loading flag.
    //
    // The individaul individual step components may contain their own internal state, but again,
    // what the server sends is the truth.
    //
    // This component, in addition to managing the components that are shown, is also where all
    // the logic to submit from the server and handle updates is contained.
export class Checkout extends React.Component {
        static propTypes = {
            // Event ID
            event_id: PropTypes.number.isRequired,
            // Event name
            event_name: PropTypes.string.isRequired,
            // true if the event is free
            free: PropTypes.bool,
            // currency used for this event
            currency: PropTypes.string,
            // Class name for "Buy Tickets" button
            buy_tickets_class: PropTypes.string,
            // Label for "Buy Tickets" button
            buy_tickets_label: PropTypes.string,
            // Class name for "Register" button (free)
            register_class: PropTypes.string,
            // Label for "Register" button (free)
            register_label: PropTypes.string,
            // Automatically open checkout
            openCheckout: PropTypes.bool,
            // Flag indicating that this hosts the modal container
            isModalContainer: PropTypes.bool,
            // Modal coordinator instance
            modalCoordinator: PropTypes.object,
            // Start in refund mode
            refund: PropTypes.bool,
            // Start in confirm mod
            confirm: PropTypes.bool
          };

        static defaultProps = {
            free: false,
            currency: 'usd',
            buy_tickets_class: "",
            buy_tickets_label: "Buy Tickets",
            register_class: "",
            register_label: "Register",
            openCheckout: false,
            event: {},
            isModalContainer: true
          };

        constructor(props) {
          super(props);
          this.componentWillUnmount = this.componentWillUnmount.bind(this);
          this.componentDidUpdate = this.componentDidUpdate.bind(this);
          this.onModalCoordinatorShow = this.onModalCoordinatorShow.bind(this);
          this.onModalCoordinatorHide = this.onModalCoordinatorHide.bind(this);
          this.onModalCoordinatorStartLoading = this.onModalCoordinatorStartLoading.bind(this);
          this.onModalCoordinatorStopLoading = this.onModalCoordinatorStopLoading.bind(this);
          this.onBuyTicketsClick = this.onBuyTicketsClick.bind(this);
          this.onCancelClick = this.onCancelClick.bind(this);
          this.onHideModal = this.onHideModal.bind(this);
          this.onApplyPromoCode = this.onApplyPromoCode.bind(this);
          this.onRemovePromoCode = this.onRemovePromoCode.bind(this);
          this.onQuantitySubmit = this.onQuantitySubmit.bind(this);
          this.onSubmitRefund = this.onSubmitRefund.bind(this);
          this.setButtonRef = this.setButtonRef.bind(this);
          this.renderWaiting = this.renderWaiting.bind(this);
          this.onAttendeeSubmit = this.onAttendeeSubmit.bind(this);
          this.onAttendeeGoBack = this.onAttendeeGoBack.bind(this);
          this.onPaymentGoBack = this.onPaymentGoBack.bind(this);
          this.onPaymentSubmit = this.onPaymentSubmit.bind(this);
          this.onConfirmOrderGoBack = this.onConfirmOrderGoBack.bind(this);
          this.onConfirmOrderSubmit = this.onConfirmOrderSubmit.bind(this);
          this.onAgreementStateChange = this.onAgreementStateChange.bind(this);
          this.onStartOverClick = this.onStartOverClick.bind(this);
          this.onRequestRefund = this.onRequestRefund.bind(this);
          this.render = this.render.bind(this);
          this._clearError = this._clearError.bind(this);
          this._url = this._url.bind(this);
          this._setLoading = this._setLoading.bind(this);
          this._dispatchOrderCompleteEvent = this._dispatchOrderCompleteEvent.bind(this);
          this._formatInstanceDate = this._formatInstanceDate.bind(this);
this._hasRefundableTickets = this._hasRefundableTickets.bind(this);

          this.loadStripePromise = null;

          this.state = {
            // True when there's some busy indicator
            loading: false,
            // The waiting state, i.e. hasn't clicked the button
            mode: 'waiting',
            // Any error state
            error: false,
            errorMessage: '',
            // True to force focus on the button (when closing)
            focusButton: false,
            // Flag indicating the checkout modal is opened somewhere on the page
            checkoutOpen: false,
            // Flag set when this is the instance that caused checkout to be shown
            didOpenCheckout: true,
            // Flag set when modal was autoOpened
            autoOpenedModal: false
          };

          this.localStore = new LocalSessionStore;

          // If completed order ID is indicated, set the defined ticket here, and flag we want to call finalize
          if (props.completed_ticket_order_id) {
            this.localStore.set(`registration_${props.event_id}`, {order_id: props.completed_ticket_order_id, cart_id: props.completed_ticket_order_cart_id}, 7 * 86400);
            this.need_to_call_finalize = true;
          }

          if (props.cart_id) { this.state.cart_id = props.cart_id; }
          if (props.order_id) { this.state.order_id = props.order_id; }

          if (props.refund || props.confirm) {
            this.state.loading = true;
            this.state.mode = props.refund ? 'refund' : 'confirmation';
            this.state.order_id = props.order_id;
            this.state.ticket_id = props.ticket_id;
            this.state.token = props.token;
          } else if (this.localStore.get(`registration_${props.event_id}`)) {
            const registration_data = this.localStore.get(`registration_${props.event_id}`);
            if (registration_data.token || this.need_to_call_finalize) {
              this.state.mode = 'confirmation';
              this.state.order_id = registration_data.order_id;
              this.state.cart_id = registration_data.cart_id;
              this.state.token = registration_data.token;
              this.state.loading = true;
              this.need_to_call_order_details = true;
            }
          }
        }

        componentDidMount() {
          // Subscribe to state changes from the modal coordinator
          this.props.modalCoordinator.subscribe('modalShow', this.onModalCoordinatorShow);
          this.props.modalCoordinator.subscribe('modalHide', this.onModalCoordinatorHide);
          this.props.modalCoordinator.subscribe('startLoading', this.onModalCoordinatorStartLoading);
          this.props.modalCoordinator.subscribe('stopLoading', this.onModalCoordinatorStopLoading);

          // If we were signaled that we need to finalize the order, call it now
          if (this.need_to_call_finalize) {
            this._finalizeCheckout();
          } else if (this.need_to_call_order_details) {
            this._getOrderDetails({order_id: this.state.order_id, token: this.state.token});
          }

          // Automatically open checkout if the URL requests it
          if (this.props.openCheckout) {
            if (this.props.refund || this.props.confirm) {
              const options = {order_id: this.state.order_id, ticket_id: this.state.ticket_id, token: this.state.token};
              if (this.props.refund) { options['refund'] = 1; }
              if (this.props.confirmation) { options['confirmation'] = 1; }
              return this._getOrderDetails(options);
            } 
              return this.onBuyTicketsClick(new Event('auto-open-checkout'));
            
          } 
            // Debugging: Simulate mode transitions by faking data
            let event_instance_id = 258490;
            switch (this.props.initialMode) {
              case 'tickets':
                return this.onBuyTicketsClick(new Event('dummy'));
              case 'attendees':
                return this.onBuyTicketsClick(new Event('dummy')).then(() => {
                  event_instance_id = this.state.instances[0].id;
                  const ticket_quantities = {};
                  ticket_quantities[this.state.ticket_class_groups[0][1][0].id] = 1;
                  return this.onQuantitySubmit({ event_instance_id, ticket_quantities });
              });
              case 'payments':
                return this.onBuyTicketsClick(new Event('dummy')).then(() => {
                  event_instance_id = this.state.instances[0].id;
                  const ticket_quantities = {};
                  ticket_quantities[this.state.ticket_class_groups[0][1][0].id] = 1;
                  return this.onQuantitySubmit({ event_instance_id, ticket_quantities });
              })
                .then(() => {
                  event_instance_id = this.state.instances[0].id;
                  const attendees = {};
                  attendees[this.state.ticket_class_groups[0][1][0].id] = [
                    {name: 'Test User', email: 'registered@localist.user'}
                  ];

                  return this.onAttendeeSubmit({ event_instance_id, attendees });
              });
              case 'confirmation':
                return this.onBuyTicketsClick(new Event('dummy')).then(() => {
                  event_instance_id = this.state.instances[0].id;
                  const ticket_quantities = {};
                  ticket_quantities[this.state.ticket_class_groups[0][1][0].id] = 1;
                  return this.onQuantitySubmit({ event_instance_id, ticket_quantities });
              })
                .then(() => {
                  event_instance_id = this.state.instances[0].id;
                  const attendees = {};
                  attendees[this.state.ticket_class_groups[0][1][0].id] = [
                    {name: 'Test User', email: 'registered@localist.user'}
                  ];

                  return this.onAttendeeSubmit({ event_instance_id, attendees });
              })
                .then(() => {
                  event_instance_id = this.state.instances[0].id;
                  return this.onPaymentSubmit({event_instance_id, token: 'tok_visa', billing_name: 'Joe Test', billing_email: 'joe.test@localist.test'});
                });
            }
          
        }

        componentWillUnmount() {
          // Clean up subscriptions to the modal coordinator, to avoid memory leaks
          this.props.modalCoordinator.unsubscribe('modalShow', this.onModalCoordinatorShow);
          this.props.modalCoordinator.unsubscribe('modalHide', this.onModalCoordinatorHide);
          this.props.modalCoordinator.unsubscribe('startLoading', this.onModalCoordinatorStartLoading);
          return this.props.modalCoordinator.unsubscribe('stopLoading', this.onModalCoordinatorStopLoading);
        }

        componentDidUpdate(prevProps) {
          if (this.state.focusButton && this._buttonRef) {
            this.setState({focusButton: false});
            const buttonRef = this._buttonRef;
            return setTimeout((() => buttonRef.focus()), 0);
          }
        }

        // Modal coordinator callbacks
        onModalCoordinatorShow(event) {
          this.setState({checkoutOpen: true});

          if (this.props.isModalContainer) {
            const registration_data =  this.localStore.get(`registration_${this.props.event_id}`);
            if (registration_data && registration_data.token) {
              this.setState({mode: 'confirmation'});
              return;
            }

            if (this.state.loading) { return; }
            return this._getTicketList();
          }
        }

        onModalCoordinatorHide(event) {
          this.setState({checkoutOpen: false});

          if (this.state.didOpenCheckout) {
            this.setState({focusButton: true, didOpenCheckout: false});
          }

          if (this.props.isModalContainer) {
            return this.setState({mode: 'waiting', loading: false});
          }
        }

        onModalCoordinatorStartLoading(event) {
          return this.setState({loading: true});
        }

        onModalCoordinatorStopLoading(event) {
          return this.setState({loading: false});
        }

        onBuyTicketsClick(event) {
          event.preventDefault();
          this.setState({didOpenCheckout: true});
          return this.props.modalCoordinator.showModal();
        }

        // Handler to cancel the transaction, releasing holds and clearing session
        onCancelClick(event) {
          this._cancelReservations();
          // Immediately transition back to waiting state, letting the reset happen in the background
          return this.props.modalCoordinator.hideModal();
        }

        onHideModal(event) {
          return this.props.modalCoordinator.hideModal();
        }

        onApplyPromoCode(promo_code) {
          return this._getTicketList({ promo_code });
        }

        onRemovePromoCode() {
          return this._getTicketList({promo_code: ''});
        }

        onQuantitySubmit(data) {
          if (this.state.loading) { return; }
          return this._reserveTickets(data);
        }

        onSubmitRefund(data) {
          const options = immutable(data)
            .set('order_id', this.state.order_id)
            .set('ticket_id', this.state.ticket_id)
            .set('token', this.state.token)
            .value();

          return this._submitRefund(options);
        }

        // Render the ticket quantity chooser
        renderTickets() {
          return <FocusFirst key="tickets" delay={100} restoreLostFocus={true}>
            <QuantityChooser {...this.props}
                             {...this.state}
                             onSubmit={this.onQuantitySubmit}
                             onCancel={this.onCancelClick}
                             onHideModal={this.onHideModal}
                             onApplyPromoCode={this.onApplyPromoCode}
                             onRemovePromoCode={this.onRemovePromoCode}/>
          </FocusFirst>;
        }

        setButtonRef(ref) { return this._buttonRef = ref; }

        renderWaiting() {
          if (!this.state.loading && this.state.checkoutOpen) {
            // Rendering null keeps the behavior of the button disappearing while the modal is open, but we want it
            // to be visible while loading (for the "Checking" message)
            return null;
          } 
            return <BuyTicketsButton {...this.props}
                               buttonRef={this.setButtonRef}
                               className={this.props.checkoutButtonClassName}
                               error={this.state.error}
                               errorMessage={this.state.errorMessage}
                               loading={this.state.loading}
                               autoFocus={this.state.hasBeenOpened}
                               onClick={this.onBuyTicketsClick} />;
          
        }

        onAttendeeSubmit(data) {
          return this._submitAttendees(data);
        }

        onAttendeeGoBack(data) {
          // Immediately go back to 'tickets', and handle updates in background
          this.setState({mode: 'tickets'});
          return this._submitAttendees(data, 'tickets');
        }


        // Render the attendee info form
        renderAttendeeDetails() {
          return <FocusFirst key="attendees" restoreLostFocus={true}>
            <AttendeeDetails {...this.props}
                             {...this.state}
                             onSubmit={this.onAttendeeSubmit}
                             onCancel={this.onCancelClick}
                             onHideModal={this.onHideModal}
                             onGoBack={this.onAttendeeGoBack}/>
          </FocusFirst>;
        }


        onPaymentGoBack(data) {
          // Don't worry about saving/restoring anything for the payment
          //
          // Because the inputs are via Stripe, we can't access them anyway
          return this.setState({mode: 'attendees'});
        }

        onPaymentSubmit(data) {
          return this._submitPayment(data);
        }

        renderPayment(stripe, elements) {
          return <FocusFirst key="payment" restoreLostFocus={true}>
            <Payment {...this.props}
                     {...this.state}
                     stripe={stripe}
                     elements={elements}
                     onSubmit={this.onPaymentSubmit}
                     onCancel={this.onCancelClick}
                     onHideModal={this.onHideModal}
                     onGoBack={this.onPaymentGoBack}/>
          </FocusFirst>;
        }

        onConfirmOrderGoBack(data) {
          return this.setState({mode: 'payment'});
        }

        onConfirmOrderSubmit(data) {
          return this._submitConfirmOrder(data);
        }

        onAgreementStateChange(data) {
          return this.setState({agreement_state: data});
        }

        renderConfirmOrder(stripe, elements) {
          return <FocusFirst key="confirm_order" restoreLostFocus={true}>
            <ConfirmOrder {...this.props}
                         {...this.state}
                         stripe={stripe}
                         elements={elements}
                         onSubmit={this.onConfirmOrderSubmit}
                         onCancel={this.onCancelClick}
                         onGoBack={this.onConfirmOrderGoBack}
                         onAgreementStateChange={this.onAgreementStateChange} />
          </FocusFirst>;
        }

        onStartOverClick() {
          this._cancelReservations().then(() => {
            this.props.modalCoordinator.hideModal();
            return this.onBuyTicketsClick(new Event('dummy'));
          });

          // Immediately transition back to waiting state, letting the reset happen in the background
          return this.setState({mode: 'waiting', loading: true});
        }

        onRequestRefund() {
          this.setState({loading: true});

          const options = {order_id: this.state.order_details.order.order_id, token: this.state.order_details.order.token, refund: 1};

          return this._getOrderDetails(options);
        }

        renderConfirmation() {
          if (!this.state.autoOpenedModal) {
            this.setState({autoOpenedModal: true});
            this.props.modalCoordinator.showModal(new Event('auto-open-modal'));
          }

          return <FocusFirst key="confirmation" restoreLostFocus={true}>
            <Confirmation {...this.props}
                         {...this.state}
                         onCancel={this.onStartOverClick}
                         onRequestRefund={this.onRequestRefund}
                         formatInstanceDate={this._formatInstanceDate}
                         hasRefundableTickets={this._hasRefundableTickets} />
          </FocusFirst>;
        }

        renderRefundRequest() {
          return <FocusFirst key="refund" restoreLostFocus={true}>
            <RefundRequest {...this.props}
                    {...this.state}
                    onSubmitRefund={this.onSubmitRefund}
                    formatInstanceDate={this._formatInstanceDate}
                    hasRefundableTickets={this._hasRefundableTickets} />
          </FocusFirst>;
        }

        renderRefundConfirmation() {
          return <FocusFirst key="refund_confirmation" restoreLostFocus={true}>
            <RefundConfirmation {...this.props}
                                {...this.state}
                                refund_success_ids={this.state.refund_success_ids}
                                refund_failure_ids={this.state.refund_failure_ids}
                                cancel_success_ids={this.state.cancel_success_ids}
                                formatInstanceDate={this._formatInstanceDate} />
          </FocusFirst>;
        }

        // Render the inner components for the current mode
        renderInner(stripe, elements) {
          switch (this.state.mode) {
            case 'waiting': return this.renderWaiting();
            case 'tickets': return this.renderTickets();
            case 'attendees': return this.renderAttendeeDetails();
            case 'payment': return this.renderPayment(stripe, elements);
            case 'confirm_order': return this.renderConfirmOrder(stripe, elements);
            case 'confirmation': return this.renderConfirmation();
            case 'refund': return this.renderRefundRequest();
            case 'refund_confirmation': return this.renderRefundConfirmation();
            default:
              console.error('unknown checkout mode', this.state.mode);

              return <p>FIXME Unknown Mode: {this.state.mode}</p>;
          }
        }

        // Render the component, wrapping in a StripeProvider
        render() {
          if (this.state.mode === 'waiting') {
            // Don't wrap waiting in a stripe provider. We don't know yet if there's a stripe API key to use
            // (that comes with the up-to-date ticket data requested by clicking the register button), and
            // StripeProvider doesn't seem to properly reinitialize Stripe if an apiKey is passed in
            // after passing in a null stripe object.
            return this.renderInner(null, null);
          } 
            // Render it wrapped in stripe
            let ElementsComponent; let ElementsConsumerComponent; let stripeElementsOptions; let stripePromise;
            const stripe_provider_props = {};
            if (this.state.stripe_api_key) {
              if (!this.loadStripePromise) { this.loadStripePromise = loadStripe(this.state.stripe_api_key); }
              stripePromise = this.loadStripePromise;
              stripeElementsOptions = {
                clientSecret: this.state.payment_intent_client_secret,
                appearance: {
                  labels: "floating",
                }
              };
            } else {
              stripePromise = null;
              stripeElementsOptions = null;
            }

            // Use dummy components until we have a Stripe payment intent
            if (this.state.payment_intent_client_secret) {
              ElementsComponent = Elements;
              ElementsConsumerComponent = ElementsConsumer;
            } else {
              ElementsComponent = EmptyElementsContainer;
              ElementsConsumerComponent = EmptyElementsConsumer;
            }

            const Modal = this.props.uses_modal ? RegisterModal : RegisterContainer;

            const hideHeader = (this.state.mode === 'confirmation') || (this.state.mode === 'refund') || (this.state.mode === 'refund_confirmation');

            return <Modal eventName={this.props.event_name}
                    eventLocation={this.props.event_location}
                    eventPhotoUrl={this.props.event_photo}
                    eventPhotoCaption={this.props.event_photo_caption}
                    headerLabel={this.props.header_label}
                    onCancel={this.onCancelClick}
                    onHideModal={this.onHideModal}
                    modalContainerElement={this.props.modalContainerElement}
                    isModalContainer={this.props.isModalContainer}
                    hideHeader={hideHeader}>
              <ElementsComponent stripe={stripePromise} options={stripeElementsOptions}>
                <ElementsConsumerComponent>
                  {({ stripe, elements }) =>
                    this.renderInner(stripe, elements)
                  }
                </ElementsConsumerComponent>
              </ElementsComponent>
            </Modal>;
          
        }

        // Clear error state
        _clearError() {
          return this.setState({error: false, errorMessage: null});
        }

        // Generate the URL for the specified endpoint
        _url(endpoint, include_cart_id) {
          if (include_cart_id == null) { include_cart_id = true; }
          if (endpoint !== "") { endpoint = `/${endpoint}`; }
          endpoint = `/event/${this.props.event_id}/tickets${endpoint}`;
          if (this.state.cart_id) { endpoint = `${endpoint}?cart_id=${this.state.cart_id}`; } // Append cart ID if we have one

          return endpoint;
        }

        _setLoading(isLoading) {
          this.setState({loading: isLoading});
          if (isLoading) {
            return (this.props.modalCoordinator != null ? this.props.modalCoordinator.startLoading() : undefined);
          } 
            return (this.props.modalCoordinator != null ? this.props.modalCoordinator.stopLoading() : undefined);
          
        }

        // Request the list of available tickets and dates from the server, optionally with additional options
        //
        // The options supported are:
        //   +promo_code+ The requested promo code to apply
        _getTicketList(options) {
          // Broadcast the loading state to other instances.
          //
          // Only this loading state change needs to be announced, as it is the only load state that happens when
          // the modal isn't shown.
          this._setLoading(true);

          return $.ajax({
            type: 'GET',
            url: this._url(''), // nothing at the end
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            this._clearError();
            this._setLoading(false);
            return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this._setLoading(false);
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error', textStatus, errorThrown);
          });
        }

        // Submit the quantities to the server, reserving the tickets and prompting for attendee details
        _reserveTickets(options) {
          this.setState({loading: true});

          return $.ajax({
            type: 'POST',
            url: this._url('hold'),
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            this._clearError();
            return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error reserving tickets', textStatus, errorThrown);
          });
        }


        // Submit the attendee details to the server, storing it and proceeding to collect payment information
        _submitAttendees(options, next_mode = null) {
          this.setState({loading: true});

          options = immutable(options)
            .set('event_instance_id', this.state.selected_instance_id)
            .value();

          return $.ajax({
            type: 'POST',
            url: this._url('attendees'),
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            this._clearError();
            let nextData = immutable.set(data, 'loading', false);
            if (next_mode) { nextData = immutable.set(nextData, 'mode', next_mode); }
            return this.setState(nextData, this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error saving attendees', textStatus, errorThrown);
          });
        }

        // Submit the payment details to the server
        _submitPayment(options) {
          this.setState({loading: true});

          return $.ajax({
            type: 'POST',
            url: this._url('payment'),
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            this._clearError();
            return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error saving payment', textStatus, errorThrown);
          });
        }

        // Submit the order confirmation  to the server
        _submitConfirmOrder(options) {
          this.setState({loading: true});

          options = immutable(options)
            .set('event_instance_id', this.state.selected_instance_id)
            .set('seen_compliance_level', this.props.compliance_level)
            .set('seen_compliance_text', this.props.compliance_text)
            .value();

          return $.ajax({
            type: 'POST',
            url: this._url('checkout'),
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            let value;
            this._clearError();

            if (data.order_status === 'payment_redirect') {
              // A browser redirect is needed to collect payment information.
              switch (data.redirect_method) {
                case 'form_post':
                  // Build a form POST and submit it
                  var form = document.createElement('form');
                  form.action = data.redirect_url;
                  form.method = 'POST';
                  form.style = 'display:none;';

                  // Create form elements
                  for (const key in data.redirect_form_data) {
                    value = data.redirect_form_data[key];
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                  }

                  // Append to document and submit
                  document.body.appendChild(form);
                  return form.submit();


                case 'redirect':
                  // Conventional redirect
                  return window.location.href = data.redirect_url;

                default:
                  // Conventional redirect for compatibility
                  return window.location.href = data.redirect_url;
              }

            } else if (data.order_status === 'confirmed') {
              // Order is complete, so store the confirmation data and display it to the user
              this.localStore.set(`registration_${data.event_id}`, {order_id: data.order_id, token: data.order_details.order.token}, 7 * 86400);
              const next_state = immutable(data)
                            .set('loading', false)
                            .set('order_id', data.order_id)
                            .set('token', data.order_details.order.token)
                            .value();

              this.setState(next_state, this._refreshBrowserTimeOffset);

              // Trigger event for CRM integration
              return this._dispatchOrderCompleteEvent(data);
            } else {
              return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
            }
          },


           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error handling payment', textStatus, errorThrown);
          });
        }

        // Request that the server clears reservations and session state
        _cancelReservations(options) {
          this.setState({loading: true});
          this.localStore.remove(`registration_${this.props.event_id}`);

          return $.ajax({
            type: 'POST',
            url: this._url('cancel'),
            dataType: 'json',
            data: options}).then((data, textStatus, jqXHR) => {
            return this.setState(function(previousState) {
              // Clear everything in state
              const nextState = {};
              for (const key in previousState) {
                nextState[key] = undefined;
              }

              // and reset it to defaults
              nextState['loading'] = false;
              nextState['mode'] = 'waiting';
              nextState['error'] = false;
              nextState['errorMessage'] = '';

              return nextState;
            });
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error cancelling reservation', textStatus, errorThrown);
          });
        }

        // Finalize the checkout
        //
        // This doesn't need to update any component state, just trigger the localist:order:complete event
        _finalizeCheckout(options) {
          if (finalize_called) { return; }

          // Mark it as called before issuing the request, to avoid multiple calls to finalize
          finalize_called = true;
          return $.ajax({
            type: 'POST',
            url: this._url('finalize'),
            dataType: 'json',
            data: options || {}})
          .then((data, textStatus, jqXHR) => {
            this.localStore.set(`registration_${this.props.event_id}`, {
              cart_id: this.props.completed_ticket_order_cart_id,
              order_id: data.order_details.order.order_id,
              token: data.order_details.order.token
            }, 7 * 86400);

            const next_state = immutable(data)
                          .set('loading', false)
                          .set('order_id', data.order_id)
                          .set('token', data.order_details.order.token)
                          .value();

            this.setState(next_state, this._refreshBrowserTimeOffset);

            if (data.order_status === 'confirmed') {
              return this._dispatchOrderCompleteEvent(data);
            }
          });
        }

        // Retrieve details for given order
        _getOrderDetails(options) {
          return $.ajax({
            type: 'GET',
            url: this._url('order_details'),
            dataType: 'json',
            data: options || {}})
          .then((data, textStatus, jqXHR) => {
            return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error getting order details', textStatus, errorThrown);
          });
        }

        // Submit a ticket refund request
        _submitRefund(data) {
          this.setState({loading: true});

          return $.ajax({
            type: 'POST',
            url: this._url('refund'),
            dataType: 'json',
            data: data || {}})
          .then((data, textStatus, jqXHR) => {
            this._clearError();
            return this.setState(immutable.set(data, 'loading', false), this._refreshBrowserTimeOffset);
          },
           (jqXHR, textStatus, errorThrown) => {
            this.setState({loading: false, error: true, errorMessage: errorThrown});
            return console.error('error refunding tickets', textStatus, errorThrown);
          });
        }

        // Refresh the browser's time offset for the server
        //
        // Assumes that the offset is consistent, so only calculate it once
        _refreshBrowserTimeOffset() {
          if (this.state.browser_time_offset) { return; }

          const now = moment(this.state.now);
          const reservation_ends_at = moment(this.state.reservationEnds);
          const time_difference = reservation_ends_at.diff(now);
          const browser_time_offset = moment().diff(now);

          return this.setState({browser_time_offset});
        }

        // Trigger the order:complete DOM CustomEvent on this element
        //
        // The event's detail is a cleaned up version of +data+
        _dispatchOrderCompleteEvent(data) {
          // Transform data
          const imm = immutable({});
          imm.set('event', data.event);
          imm.set('event.id', data.event_id);
          const selected_instance = _.find(data.instances, {id: data.selected_instance_id});
          imm.set('event.instance', selected_instance);
          imm.set('purchaser', {name: data.user_name, email: data.user_email, id: data.user_id});
          imm.set('order', {id: data.order_id, status: data.order_status, total: data.cart.total, currency: data.currency, promo_code: data.promo_code});

          // Collect attendees and group with their questions
          const question_map = data.questions.reduce(function(memo, question) {
            memo[question.id] = question.question;
            return memo;
          },
           {});

          const ticket_map = data.ticket_class_groups.reduce(function(memo, ticket_group) {
            ticket_group[1].forEach(ticket => memo[ticket.id] = ticket);
            return memo;
          },
           {});


          // Attendees is ticket_type_id => array of attendee data hashes, so we
          // need to flatten it a bit
          imm.set('attendees', []);

          for (const ticket_type_id in data.attendees) {
            const attendees = data.attendees[ticket_type_id];
            for (const attendee of Array.from(attendees)) {
              const questions = [];
              for (const question_id in attendee.answers) {
                const response = attendee.answers[question_id];
                questions.push({id: question_id, question: question_map[question_id], response});
              }

              const attendee_data = {
                name: attendee.name,
                email: attendee.email,
                ticket_type: ticket_map[ticket_type_id].name,
                questions
              };

              imm.push('attendees', attendee_data);
            }
          }

          const event_detail = imm.value();

          // Create event
          const event = new CustomEvent('localist:order:complete', {
            detail: event_detail,
            bubbles: true,
            cancelable: false,
            composed: false
          });

          // Dispatch it
          const node = ReactDOM.findDOMNode(this);
          return node.dispatchEvent(event);
        }

        // Format an instance hash as a date and time.
        //
        // The +instance+ hash should have start_date and start_time properties.
        _formatInstanceDate(instance) {
          const start_date = parseLocalDate(instance.starts_at, !instance.start_time);
          const end_date = parseLocalDate(instance.ends_at, !instance.start_time);

          return formatTime(start_date, end_date, 'detailed', { dateOnly: !instance.start_time });
        }

        _hasRefundableTickets(tickets) {
          return tickets.some(ticket => ticket["may_request_refund?"]);
        }
      }
